import React, {Component} from 'react';
import { Trans } from 'react-i18next';

class FilterInput extends Component {
  render() {
    return (
        <div className="js-form-item form-item js-form-type-textfield">
            <label htmlFor="meeting-room"><Trans i18nKey="filter_input.label_meeting_rooms">Meeting rooms</Trans></label>
            <input type="text" className="filter__number-input" id="meeting-rooms" name="meeting-rooms" size="2" maxLength="255"/>
        </div>
    );
  }
}

export default FilterInput;
